import { home } from '@/lang/nl/pages/home.ts'
import { pricing } from '@/lang/nl/pages/pricing.ts'
import { avg } from '@/lang/nl/pages/avg.ts'
import { agents } from '@/lang/nl/pages/campaigns/agents.ts'
import { gloriafood } from '@/lang/nl/pages/campaigns/gloriafood.ts'

import { manager } from '@/lang/nl/pages/products/manager.ts'
import { page } from '@/lang/nl/pages/products/page.ts'
import { pos } from '@/lang/nl/pages/products/pos.ts'
import { posdevice } from '@/lang/nl/pages/products/posdevice.ts'
import { qr } from '@/lang/nl/pages/products/qr.ts'
import { webshop } from '@/lang/nl/pages/products/webshop.ts'
import { kiosk } from '@/lang/nl/pages/products/kiosk.ts'

import { lunchroom } from '@/lang/nl/pages/cases/lunchroom.ts'
import { cafetaria } from '@/lang/nl/pages/cases/cafetaria.ts'
import { grillroom } from '@/lang/nl/pages/cases/grillroom.ts'
import { sushi } from '@/lang/nl/pages/cases/sushi.ts'
import { italian } from '@/lang/nl/pages/cases/italian.ts'

import { support } from '@/lang/nl/pages/info/support.ts'
import { faq } from '@/lang/nl/pages/info/faq.ts'
import { downloads } from '@/lang/nl/pages/info/downloads.ts'
import { integrations } from '@/lang/nl/pages/info/integrations.ts'
import { terms } from '@/lang/nl/pages/info/terms.ts'
import { google } from '@/lang/nl/pages/integrations/google.ts'
import { facebook } from '@/lang/nl/pages/integrations/facebook.ts'
import { instagram } from '@/lang/nl/pages/integrations/instagram.ts'
import { mollie } from '@/lang/nl/pages/integrations/mollie.ts'
import { stripe } from '@/lang/nl/pages/integrations/stripe.ts'
import { lightspeed } from '@/lang/nl/pages/integrations/lightspeed.ts'
import { exactonline } from '@/lang/nl/pages/integrations/exactonline.ts'
import { mpluskassa } from '@/lang/nl/pages/integrations/mpluskassa.ts'
import { twilio } from '@/lang/nl/pages/integrations/twilio.ts'
import { winstonpos } from '@/lang/nl/pages/integrations/winstonpos.ts'
import { untill } from '@/lang/nl/pages/integrations/untill.ts'
import { leat } from '@/lang/nl/pages/integrations/leat.ts'
import { slack } from '@/lang/nl/pages/integrations/slack.ts'
import { cashdesk } from '@/lang/nl/pages/integrations/cashdesk.ts'

export const pages = {
  home,
  campaigns: {
    agents,
    gloriafood,
  },
  agents,
  avg,
  products: {
    manager,
    page,
    pos,
    posdevice,
    qr,
    webshop,
    kiosk,
  },
  pricing,
  cases: {
    lunchroom,
    cafetaria,
    grillroom,
    sushi,
    italian,
  },
  info: {
    support,
    faq,
    downloads,
    integrations,
    terms,
    integrations_detail: {
      google,
      facebook,
      instagram,
      mollie,
      stripe,
      lightspeed,
      exactonline,
      mpluskassa,
      twilio,
      winstonpos,
      untill,
      leat,
      slack,
      cashdesk,
    },
  },
}
